import { useCallback, useContext } from "react";

import { ISessionUser } from "@/data/session";
import { SessionContext } from "@/infrastructure/Session";

export const useHasUserCompanyWithVat = () => {
  const Session = useContext(SessionContext);
  const sessionUser = Session.payload as ISessionUser;

  return useCallback(
    (vatNo: string, countryCode: string | null) =>
      sessionUser.consultantProfiles.some(({ sharedProfile }) => {
        if (sharedProfile && vatNo) {
          const hasVatNo = sharedProfile.company.vatNo === vatNo;
          return sharedProfile.company.countryCode === countryCode && hasVatNo;
        }
        return false;
      }),
    [sessionUser],
  );
};
